<template>
  <div class="search-menu">
    <ViewOptions v-if="RMTSearchType === 0"/>
    <SortOptions/>
    <MediaTypes v-if="RMTSearchType === 0"/>
    <div class="menu-divider"></div>
    <SelectionOptions v-if="RMTSearchType === 0 || inCreateCollectionMode"/>
    <div class="menu-divider"></div>
    <RemoveButton v-if="!inCreateCollectionMode"/>
    <div
      v-if="RMTSearchType === 1 && $props.display === 'edit'"
      class="selection"
    >
    <div
        class="circle"
        v-if="!isAddResource"
        @click="handleAddResources"
      >
        <div class="icon-size-plus">
          +
        </div>
      </div>
      <div
        class="circle"
        v-if="isAddResource"
        @click="handleExitAdd"
      >
        <div class="icon-size-minus">
          -
        </div>
      </div>
    </div>
    <div v-if="$props.display === 'add'" class="selection">
      <div class="selection-cnt">
        {{ addedCollectionCount }} selected
      </div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { useRMTStore } from '@/store/RMTStore';
import { mapStores, storeToRefs } from 'pinia/dist/pinia';
import { gsap } from 'gsap';
import SortOptions from '@/components/libraries/search/SortOptions';
import MediaTypes from '@/components/libraries/search/MediaTypes';
import ViewOptions from '@/components/libraries/search/ViewOptions';
import SelectionOptions from '@/components/libraries/search/SelectionOptions';
import RemoveButton from '@/components/libraries/search/RemoveButton';

export default {
  name: 'SearchMenu',
  components: {
    ViewOptions,
    SortOptions,
    MediaTypes,
    SelectionOptions,
    RemoveButton
  },
  props: [
    'display'
  ],
  setup () {
    const RMTStore = useRMTStore();
    const {
      RMTPermission,
      getShowCollectionSearchDisplayType,
      getAddCollectionSearchDisplayType,
      getCollectionSearchDisplayType,
      getEditCollectionSearchDisplayType,
      inCreateCollectionMode,
      searchType
    } = storeToRefs(RMTStore);
    return {
      getShowCollectionSearchDisplayType,
      getEditCollectionSearchDisplayType,
      getAddCollectionSearchDisplayType,
      getCollectionSearchDisplayType,
      RMTPermission,
      inCreateCollectionMode,
      searchType
    };
  },
  data () {
    return {
      state: {
        select_label: 'SELECT'
      }
    };
  },
  computed: {
    ...mapStores(useModalStore, useRMTStore),
    isAddResource () {
      const RMTStore = useRMTStore();
      return RMTStore.isAddResource;
    },

    selectedCollections () {
      const RMTStore = useRMTStore();
      return RMTStore.selectedCollections;
    },
    resources () {
      return this.RMTStore.resources;
    },
    inMultiSelectionMode () {
      const RMTStore = useRMTStore();
      return RMTStore.getInMultiSelectionMode;
    },
    RMTSearchType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchType;
    },
    addedCollectionCount () {
      return this.RMTStore.addedCollectionCount;
    },
    editCollectionCount () {
      return this.RMTStore.editCollectionCount;
    },
    showCollectionCount () {
      return this.RMTStore.showCollectionCount;
    },
    selections () {
      return this.RMTStore.selectedResources;
    },
    searchDisplayType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchDisplayType;
    },
    collectionSelected () {
      const RMTStore = useRMTStore();
      return RMTStore.collections.length == 1;
    }
  },
  watch: {
    getCollectionSearchDisplayType (to, from) {
      gsap.to(this.$refs[from + 'View'], {
        backgroundColor: 'lightgrey'
      });
      gsap.to(this.$refs[to + 'View'], {
        backgroundColor: '#afafaf'
      });
    },
    getAddCollectionSearchDisplayType (to, from) {
      gsap.to(this.$refs[from + 'View'], {
        backgroundColor: 'lightgrey'
      });
      gsap.to(this.$refs[to + 'View'], {
        backgroundColor: '#afafaf'
      });
    },
    getEditCollectionSearchDisplayType (to, from) {
      gsap.to(this.$refs[from + 'View'], {
        backgroundColor: 'lightgrey'
      });
      gsap.to(this.$refs[to + 'View'], {
        backgroundColor: '#afafaf'
      });
    },
    getShowCollectionSearchDisplayType (to, from) {
      gsap.to(this.$refs[from + 'View'], {
        backgroundColor: 'lightgrey'
      });
      gsap.to(this.$refs[to + 'View'], {
        backgroundColor: '#afafaf'
      });
    },

  },
  methods: {
    setCollectionSearchDisplayType (type) {
      this.RMTStore.setCollectionSearchDisplayType(type);
    },
    setEditCollectionSearchDisplayType (type) {
      this.RMTStore.setEditCollectionSearchDisplayType(type);
    },
    setAddCollectionSearchDisplayType (type) {
      this.RMTStore.setAddCollectionSearchDisplayType(type);
    },
    setShowCollectionSearchDisplayType (type) {
      this.RMTStore.setShowCollectionSearchDisplayType(type);
    },



    handleAddResources () {
      this.RMTStore.isAddResource = true;
    },
    handleExitAdd () {
      this.RMTStore.isAddResource = false;
    }
  }
};
</script>

<style scoped>
.search-menu {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-self: center;
  gap: 10px;
}

@media (max-width: 1024px) {
  .search-menu {
    font-size: .95em;
  }
}

.circle {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  background-color: lightgrey;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
}
.box {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-self: center;
  text-align: center;
  background-color: lightgrey;
  padding: 3px 11px;
  font-size: .625em;
  font-weight: bold;
}
.grid {
  margin-right: 6px;
}

.selection {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-self: center;
  flex-wrap: wrap;
}
.selection-info {
  display: flex;

  align-items: flex-start;
  justify-content: space-between;
}
.selection-buttons {
  display: flex;
}
.selection-text {
  display: flex;
  justify-content: center;
  align-self: center;
  margin-right: 10px;
  font-size: .55em;
  font-weight: 600;
  letter-spacing: .05em;
}
.select-all {
  margin-right: 5px;
}
.clear {
  cursor: pointer;
}
.disable {
  opacity: .5;
  transition: all .2s;
}
.enable {
  opacity: 1;
  transition: all .2s
}
.selection-cnt {
  display: flex;

  font-size: .6em;
}
.icon-size-del {
  width: 11px;
}
.icon-size-plus {
  font-size: 25px;
  user-select: none;
}
.icon-size-minus {
  font-size: 45px;
  user-select: none;
}
.grid-icon {
  width: 15px;
}
.list-icon {
  width: 15px;
}

.menu-divider {
  width: 1px;
  background-color: #d5d5d5;
}

</style>

<style>

.search-menu-label {
  font-weight: bold;
  font-size: .70em;
  margin-bottom: 3px;
}

</style>
